export default __webpack_public_path__ + "static/Inter-Medium-874bf62fa7ae4459712a6261599f2c31.woff2";